import Loading from '@Components/Loading/Loading'
import React from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import './ReportLayout.scss'

interface IReportLayout {
    children: React.ReactNode
    isLoading?: boolean
}

const ReportLayout = (props: IReportLayout) => {
    const { children, isLoading } = props

    return (
        <div className="report-layout">
            <Header />
            <div className="report-wrapper">
                <div className="report-content">
                    <Loading isLoading={isLoading} /> {children}
                </div>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    // console.log(state?.shareds)

    const isLoading = state?.shared?.loadings?.pageLoading
    return {
        isLoading,
    }
}

export default connect(mapStateToProps, null)(ReportLayout)
